// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.well {
  background-color: #fff;
}
.well__header {
  align-items: center;
  display: flex;
  min-height: 40px;
  padding-bottom: 5px;
  width: 100%;
  justify-content: space-between;
}
.well__header__title {
  display: inline;
  margin: 0;
}
.well__header__toolbar-wrapper {
  flex-grow: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.well > .List {
  margin: -5px -15px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/Well/Well.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;AACI;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AACR;AACQ;EACI,eAAA;EACA,SAAA;AACZ;AAEQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAZ;AAII;EAEI,kBAAA;AAHR","sourcesContent":[".well {\n    background-color: #fff;\n\n    &__header {\n        align-items: center;\n        display: flex;\n        min-height: 40px;\n        padding-bottom: 5px;\n        width: 100%;\n        justify-content: space-between;\n\n        &__title {\n            display: inline;\n            margin: 0;\n        }\n\n        &__toolbar-wrapper {\n            flex-grow: 2;\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n        }\n    }\n\n    & > .List {\n        // Accommodate the padding in the List component so that the list lines up nicely with the well\n        margin: -5px -15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
